var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menu-item",class:{ 'is-active': _vm.isActive ? _vm.isActive(): null },attrs:{"title":_vm.title},on:{"click":_vm.action}},[_c('i',{staticClass:"iconfont",class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }